/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  ComparisonFeed,
  ComparisonFeedFromJSON,
  ComparisonFeedFromJSONTyped,
  ComparisonFeedToJSON,
  ErrorResponse,
  ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped,
  ErrorResponseToJSON,
} from "./";

/**
 *
 * @export
 * @interface ComparisonFeedIEnumerableControllerResponse
 */
export interface ComparisonFeedIEnumerableControllerResponse {
  /**
   *
   * @type {Array<ComparisonFeed>}
   * @memberof ComparisonFeedIEnumerableControllerResponse
   */
  data?: Array<ComparisonFeed> | null;
  /**
   *
   * @type {ErrorResponse}
   * @memberof ComparisonFeedIEnumerableControllerResponse
   */
  error?: ErrorResponse;
}

export function ComparisonFeedIEnumerableControllerResponseFromJSON(
  json: any,
): ComparisonFeedIEnumerableControllerResponse {
  return ComparisonFeedIEnumerableControllerResponseFromJSONTyped(json, false);
}

export function ComparisonFeedIEnumerableControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ComparisonFeedIEnumerableControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data")
      ? undefined
      : json["data"] === null
        ? null
        : (json["data"] as Array<any>).map(ComparisonFeedFromJSON),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function ComparisonFeedIEnumerableControllerResponseToJSON(
  value?: ComparisonFeedIEnumerableControllerResponse | null,
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data:
      value.data === undefined
        ? undefined
        : value.data === null
          ? null
          : (value.data as Array<any>).map(ComparisonFeedToJSON),
    error: ErrorResponseToJSON(value.error),
  };
}
